import styled from '@emotion/styled';
import { StepLabel } from '@mui/material';

export const VyStepLabel = styled(StepLabel)({
  ['& .Mui-active']: {
    color: '#458FFF !important',
  },
});